import { Cookie } from './Cookie';

export abstract class CookieFactory {
  static get consentCookie() {
    return new Cookie({ key: 'consent-digitale-helden' });
  }
}
